import {KeyTestFormField} from "../types/key-tests-modal.types";
import {keyTestRowFormFields} from "./key-tests-form-fields";

export function keyTestFields(): Array<KeyTestFormField> {
  return keyTestRowFormFields.flatMap(row => row.fields);
}
